import { Button } from "flowbite-react";
import { ClipboardList, X } from "lucide-react";
import { toast } from "sonner";
import { H5 } from "@/shared/ui/typographies/h5";
import { P } from "@/shared/ui/typographies/paragraph";

type MandatoryFieldsToastProps = {
  toastId: string | number
  missingFields?: { name: string }[]
  onDismiss?: () => void
  onNavigateToProfile: () => void
};

const MandatoryFieldsToast = ({
  toastId,
  missingFields,
  onDismiss,
  onNavigateToProfile,
}: MandatoryFieldsToastProps) => {
  const handleCompleteProfile = () => {
    toast.dismiss(toastId);
    onNavigateToProfile();
    onDismiss?.();
  };

  const handleDismiss = () => {
    toast.dismiss(toastId);
    onDismiss?.();
  };

  return (
    <div className="w-80 max-w-sm rounded-lg shadow-lg bg-white dark:bg-gray-800 p-4 relative">
      <button
        onClick={handleDismiss}
        className="absolute top-5 right-5 text-amber-700 dark:text-amber-400 hover:text-amber-900 dark:hover:text-amber-300 transition-colors z-10"
        aria-label="Fermer"
      >
        <X size={20} />
      </button>

      <div className="bg-amber-100 dark:bg-amber-900/30 rounded-lg p-6 flex items-center justify-center mb-4">
        <ClipboardList
          size={32}
          className="text-amber-600 dark:text-amber-500"
        />
      </div>

      <div className="space-y-3">
        <H5 className="text-gray-900 dark:text-white">
          Champs obligatoires manquants
        </H5>

        <P size="sm" color="base">
          Veuillez compléter votre profil pour accéder à toutes les
          fonctionnalités.
        </P>

        {missingFields && missingFields.length > 0 && (
          <div className="pt-2">
            <P size="sm" color="base" className="mb-2">
              Champs manquants :
            </P>
            <ul className="list-disc list-inside space-y-1">
              {missingFields.map((field) => (
                <li key={field.name}>
                  <P size="sm" color="base" className="inline">
                    {field.name}
                  </P>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="pt-2">
          <Button color="primary" fullSized onClick={handleCompleteProfile}>
            Compléter mon profil
          </Button>
        </div>
      </div>
    </div>
  );
};

MandatoryFieldsToast.displayName = "MandatoryFieldsToast";

export { MandatoryFieldsToast };
export type { MandatoryFieldsToastProps };
